module.exports = __webpack_public_path__ + "img/bezier-curve.f1cce925.svg";